import React from 'react';

import { useState } from 'react';
import { Buttons, ChooseCountries } from 'components';

const ChooseCountriesBtn = ({ title, selectedCountries, saveButtonAction }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Countries
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ChooseCountries
          isOpen={isOpen}
          title={title}
          selectedCountries={selectedCountries}
          saveButtonAction={saveButtonAction}
          close={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default ChooseCountriesBtn;
